import { BasicUser } from './basicUser.model';
import { FinancialSnapshot } from './financials/financial-snapshot.model';
import { Compliance } from './compliance.interface';
import { Attachment } from './attachment';
import { Reference } from './reference.model';

/** Metadata for notes originating from forwarded emails via TARA */
export interface EmailMetadata {
  subject?: string;
  from?: string;
  toRecipients?: Array<string>;
  ccRecipients?: Array<string>;
  forwardedToRecipients?: Array<string>;
  forwardedCcRecipients?: Array<string>;
  emailDate?: string;
  forwardedToRmsDate?: string;
  forwardedBy?: string;
}

export class TextContent {
  id: 2;
  textContentType: string;
  contentStatusType: string;
  content: string;
  timestamp: string;
  parentId: number;
  expirationDate: string;
  expirationWarningDate: string;
  validEditUntilDate: string;
  lockedForEdit: symbol;
  lockOwnerUserId: number;
  lockOwnerDisplayName: string;
  createdBy: BasicUser;
  updatedBy: BasicUser;
  financials: FinancialSnapshot;
  compliance: Compliance;
  attachments: Array<Attachment>;
  references: Array<Reference>;
  active: boolean;
  created: string;
  lastEditedTimestamp: string;
  updated: string;
  maps?: Array<any>;
  isOverview?: boolean;
  isTaraNote?: boolean;
  emailMetadata?: EmailMetadata;
}
